"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.issues = exports.IssueEnum = void 0;
var IssueEnum;
(function (IssueEnum) {
    IssueEnum[IssueEnum["Price"] = 1] = "Price";
    IssueEnum[IssueEnum["Mileage"] = 2] = "Mileage";
    IssueEnum[IssueEnum["VIN"] = 3] = "VIN";
    IssueEnum[IssueEnum["Condition"] = 4] = "Condition";
    IssueEnum[IssueEnum["MakeModel"] = 5] = "MakeModel";
    IssueEnum[IssueEnum["Year"] = 6] = "Year";
})(IssueEnum || (exports.IssueEnum = IssueEnum = {}));
exports.issues = [
    {
        id: IssueEnum.Price,
        name: 'Price is too low or too hight'
    },
    {
        id: IssueEnum.Mileage,
        name: 'Mileage is too high'
    },
    {
        id: IssueEnum.VIN,
        name: 'VIN is missing or invalid'
    },
    {
        id: IssueEnum.Condition,
        name: 'Condition is questionable'
    },
    {
        id: IssueEnum.MakeModel,
        name: 'Make/Model is missing'
    },
    {
        id: IssueEnum.Year,
        name: 'Year is older than 1900'
    }
];
